import { render, staticRenderFns } from "./DSRs.vue?vue&type=template&id=91fb6092&"
import script from "./DSRs.vue?vue&type=script&lang=js&"
export * from "./DSRs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports